import { FaqSearchIcon } from '@orcar/common-d2c';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  CS_CENTER_SECTION,
  FAQ_LIST,
  NOTICE_LIST,
} from '@/constants/cs-center';
import * as S from './styles';
import FaqCard from '../FaqCard';
import NoticeCard from '../NoticeCard';
import PetGuideSection from '../PetGuideSection';

const MobileCustomerServiceLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const section = searchParams.get('section') || CS_CENTER_SECTION.NOTICE;

  const [filteredFaqList, setFilteredFaqList] = useState(FAQ_LIST);

  const onSubmit = (e: any) => {
    e.preventDefault();
    const text = e.target[0].value;
    const filteredFaqs = FAQ_LIST.filter((faq) => faq.query.includes(text));
    setFilteredFaqList(filteredFaqs);
  };

  return (
    <S.Wrapper>
      <S.Header>
        <S.Tab
          isActive={section === CS_CENTER_SECTION.NOTICE}
          onClick={() =>
            setSearchParams((params) => {
              params.set('section', CS_CENTER_SECTION.NOTICE);
              return params;
            })
          }
        >
          공지사항
        </S.Tab>
        <S.Tab
          isActive={section === CS_CENTER_SECTION.FAQ}
          onClick={() =>
            setSearchParams((params) => {
              params.set('section', CS_CENTER_SECTION.FAQ);
              return params;
            })
          }
        >
          자주 묻는 질문
        </S.Tab>
        <S.Tab
          isActive={section === CS_CENTER_SECTION.PET}
          onClick={() =>
            setSearchParams((params) => {
              params.set('section', CS_CENTER_SECTION.PET);
              return params;
            })
          }
        >
          반려동물 동반
        </S.Tab>
        {/* <S.Tab
          isActive={currentSection === CS_CENTER_SECTION.ONE_TO_ONE}
          onClick={() =>
            router.push({
              pathname: '/cs-center',
              query: { section: CS_CENTER_SECTION.ONE_TO_ONE },
            })
          }
        >
          1:1 문의하기
        </S.Tab> */}
      </S.Header>
      {/* {currentSection === CS_CENTER_SECTION.ONE_TO_ONE && (
        <S.SubTabWrapper>
          <S.SubTab
            onClick={() => {
              router.push({
                query: {
                  section: CS_CENTER_SECTION.ONE_TO_ONE,
                  isAsking: true,
                },
              });
            }}
            isActive={
              currentSection === CS_CENTER_SECTION.ONE_TO_ONE && isAsking
            }
          >
            문의하기
          </S.SubTab>
          <S.SubTab
            onClick={() => {
              router.push({
                query: {
                  section: CS_CENTER_SECTION.ONE_TO_ONE,
                  isAsking: false,
                },
              });
            }}
            isActive={
              currentSection === CS_CENTER_SECTION.ONE_TO_ONE && !isAsking
            }
          >
            문의 내역
          </S.SubTab>
        </S.SubTabWrapper>
      )} */}

      {section === CS_CENTER_SECTION.FAQ && (
        <FaqInputWrapper>
          <form onSubmit={onSubmit}>
            <FaqFilterInput placeholder='궁금한 내용을 검색해 보세요.' />

            <IconWrapper type='submit'>
              <SearchIcon
                src={FaqSearchIcon}
                width={32}
                height={32}
                alt='돋보기'
              />
            </IconWrapper>
          </form>
        </FaqInputWrapper>
      )}
      {section === CS_CENTER_SECTION.NOTICE ? (
        <>
          {NOTICE_LIST.map((noticeItem) => {
            return (
              <NoticeCard
                key={noticeItem.title}
                title={noticeItem.title}
                date={noticeItem.date}
                detail={noticeItem.detail}
              />
            );
          })}
        </>
      ) : section === CS_CENTER_SECTION.FAQ ? (
        <>
          {filteredFaqList.map((faqItem) => {
            return (
              <FaqCard
                key={faqItem.query}
                query={faqItem.query}
                answer={faqItem.answer}
              />
            );
          })}
        </>
      ) : section === CS_CENTER_SECTION.PET ? (
        <PetGuideSection />
      ) : null}
    </S.Wrapper>
  );
};

export default MobileCustomerServiceLayout;

const FaqInputWrapper = styled.div`
  margin: 30px auto;
  margin-bottom: 10px;
  width: 320px;
  height: 40px;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
`;

const FaqFilterInput = styled.input`
  width: 320px;
  height: 40px;
  ${({ theme }) => theme.FONT.B2};
  font-weight: 400;
  border: ${({ theme }) => `1px solid ${theme.COLOR.GREY_05}`};
  background: ${({ theme }) => theme.COLOR.WHITE};
  padding: 12px 0 11px 16px;
  outline: none;
`;

const IconWrapper = styled.button`
  width: 32px;
  height: 32px;
  position: relative;
  left: 282px;
  bottom: 36px;
`;

const SearchIcon = styled.img``;

const EmptyHistory = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  color: ${({ theme }) => theme.COLOR.GREY_01};
  font-size: 16px;
  font-weight: 600;
  line-height: 19.09px;
`;
